module.exports = __webpack_public_path__ + "img/windows-3-tw.32d328f7.png";